// Small fetch-based actions for QBO interactions that don't need their own
// hook. Returns plain { ok, error } objects so the caller controls UI state.

function csrf() {
  return document.querySelector('meta[name="csrf-token"]')?.content || '';
}

// POST /quickbooks/sync (or whatever Rails route the page was given) to
// kick off a P&L resync. Returns { ok: true } on a 2xx; { ok: false, error }
// otherwise.
// eslint-disable-next-line import/prefer-default-export
export async function triggerQboSync(syncUrl) {
  if (!syncUrl) return { ok: false, error: null };
  try {
    const res = await fetch(syncUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-Token': csrf() },
    });
    const data = await res.json();
    if (res.ok) return { ok: true };
    return { ok: false, error: data.error || 'Sync failed. Please try again.' };
  } catch (e) {
    return { ok: false, error: 'Sync failed. Please try again.' };
  }
}
